export const ROOT_URL="http://www.dpharmakluj.org";